module.exports = __webpack_public_path__ + "static/media/invoices_converter.369879f1.jpg";